import type { AxiosError } from 'axios';

import type { ApiError } from '../../types';

export const getErrorMessage = (err: AxiosError<ApiError>): string => {
  try {
    const msg = Array.isArray(err.response?.data.detail)
      ? err.response?.data.detail[0].toString()
      : err.response?.data.detail.toString();
    return msg || 'An unknown error occurred';
  } catch (error) {
    return 'An unknown error occurred';
  }
};
